export function getIntlNumberSeparators(language = window.navigator.language) {
  const formatter = new Intl.NumberFormat(language);
  const parts = formatter.formatToParts(1234567.89);
  let thousandSeparator = '';
  let decimalSeparator = '';

  parts.forEach((part) => {
    if (part.type === 'group') {
      thousandSeparator = part.value;
    }
    if (part.type === 'decimal') {
      decimalSeparator = part.value;
    }
  });

  return { thousandSeparator, decimalSeparator };
}
